import React from 'react';

export default class Page1 extends React.Component {

    render() {

        return <div id="region-main-pad">
            <div id="region-main"><span id="user-notifications"/>
                <div className="region-content">
                    <div role="main"><span id="maincontent"/>
                        <section>
                            <div className="">
                                <div className="ilead-rgt people">
                                    <div className="innerpadding">
                                        <div className="innovativeimg">
                                            <img
                                                src={require('@images/How to develop others.png')}
                                                alt=""/>
                                        </div>

                                        <div className="ilead-contentarea">

                                            <div className="circle_title">
<span className="heading">
<img className="heading_image" src={require('@images/browndot.jpg')}/>
</span>
                                                <span className="heading">isn't it interesting?</span>
                                            </div>

                                            <p>From tiny acorns mighty oaks do grow...</p>
                                            <div className="border_subtitle">Developing others</div>
                                            <p>Helping others to grow and develop is vital in the talent
                                                management strategy of any organisation.
                                                We know that providing development goals that are stretching but
                                                attainable is the first step, but
                                                people don’t learn and develop in isolation – others play an
                                                important part in the process too.
                                                ‘Scaffolding’, i.e. providing support at the outset but then
                                                gradually reducing it as someone
                                                becomes more proficient, is a technique that can help to
                                                increase competence and development.<a
                                                    className="superscripttext"
                                                    href="further_info.php?course=300"><sup>1</sup></a>
                                                A key part of the scaffolding process is giving feedback, the
                                                importance of which was highlighted
                                                in the study below.</p>


                                            <div className="lightgreencontentbg keyquestionpad">
                                                <div className="border_subtitle">The importance of feedback
                                                </div>
                                                <p>Using a natural setting to investigate the importance of
                                                    feedback, psychologists set up an
                                                    experiment in a high school in the Basque region of
                                                    France.<a className="superscripttext"
                                                              href="further_info.php?course=300"><sup>2</sup></a> For
                                                    a year, they provided
                                                    regular updates to the schoolchildren about where they
                                                    ranked compared to the class
                                                    average and how far away they were from it. As a result, the
                                                    class exam average went up
                                                    by 5% overall; however, after the year was over, the
                                                    improvement from the experimental
                                                    year disappeared.</p>
                                                <div className="uiheading"><p>It is possible to draw two
                                                    important conclusions from this data. Firstly, that regular
                                                    objective
                                                    feedback can obviously be an important motivator, whether it
                                                    is positive (being higher than
                                                    the average), or negative (being lower than the average).
                                                    However, it is just as important to
                                                    maintain this feedback, and also for it to be capitalised
                                                    on, otherwise the positive benefits
                                                    can be lost over time. This applies in the workplace as well
                                                    as the classroom, and this tool
                                                    will help you to deliver regular, effective feedback in
                                                    order to develop others.</p></div>

                                            </div>


                                            <div className="right-btn">
                                                <div onClick={this.props.handleChangePage('Page2')}
                                                     className="button-next-previous-done">Next &gt;&gt;</div>
                                            </div>


                                        </div>

                                    </div>


                                </div>


                            </div>
                        </section>
                    </div>
                </div>
            </div>
        </div>;
    }
}